// extracted by mini-css-extract-plugin
module.exports = {"listItem":"MenuItem-module--listItem--nalkQ","selected":"MenuItem-module--selected--16udf"};